<template>
<v-simple-table>
    <tbody>
    <tr>
        <td><strong>Name</strong></td>
        <td>{{ item['name'] }}</td>
    </tr>
    <tr>
        <td><strong>IBAN</strong></td>
        <td>{{ item['IBAN'] }}</td>
    </tr>
    <tr>
        <td><strong>BIC</strong></td>
        <td>{{ item['BIC'] }}</td>
    </tr>
    </tbody>
</v-simple-table>
</template>

<script>
    export default {
        name: "SepaInfoTable",
        props: ['item']
    }
</script>

<style scoped>

</style>
